<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-sub-title text="Selección de permisos" />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-autocomplete
                    :items="positions"
                    v-model="selectedPosition"
                    placeholder="Cargo"
                    @change="loadCapabilities"
                ></app-autocomplete>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-btn :disabled="!selectedPosition" @click="saveCapabilities" variant="confirm">Guardar</b-btn>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-data-table :fields="fields" :items="capabilities" :searchable="true">
                    <template slot="actions" slot-scope="props">
                        <b-form-checkbox
                            :id="`checkbox-${props.item.id}`"
                            :name="`checkbox-${props.item.id}`"
                            v-model="selectedCapabilities"
                            :value="props.item.id"
                            unchecked-value=""
                        >
                        </b-form-checkbox>
                    </template>
                </app-data-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-btn :disabled="!selectedPosition" @click="saveCapabilities" variant="confirm">Guardar</b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import { mapGetters } from 'vuex';
    import Autocomplete from '../../UI/Controls/AutocompleteV2/Autocomplete';
    import securityRepository from '../../../repositories/security.repository';
    export default {
        name: 'capabilities_manager_page',
        components: {
            appAutocomplete: Autocomplete
        },
        data: () => ({
            selectedCapabilities: [],
            selectedPosition: '',
            fields: [{
                    key: 'name',
                    label: 'Nombre'
                },
                {
                    key: 'slug',
                    label: 'Slug'
                },
                {
                    key: 'description',
                    label: 'Descripción'
                },
                {
                    key: 'type',
                    label: 'Tipo'
                },
                {
                    key: 'actions',
                    label: 'Selección'
                },
            ]
        }),
        computed: {
            ...mapGetters(['capabilities', 'positions'])
        },
        methods: {
            async loadCapabilities() {

                if(!this.selectedPosition) return this.selectedCapabilities = [];

                try {
                    const sr = {...securityRepository};
                    const {data} = await sr.getPositionCapabilities(this.selectedPosition.id);
                    this.selectedCapabilities = [];
                    data.forEach(item => this.selectedCapabilities.push(item.id));
                }catch(err) {
                    toastr.error(`Ocurrió un error cargando los permisos del cargo [${err.message}]`);
                }
            },
            async saveCapabilities() {
                const sr = {...securityRepository};
                try {
                    const {data} = await sr.savePositionCapabilities(this.selectedPosition.id, this.selectedCapabilities);
                    data.status && toastr.success('Permisos guardados satisfactoriamente');
                    !data.status && toastr.error(data.msg);
                } catch(err) {
                    toastr.error(`Ocurrió un error al guardar los permisos [${err.message}]`);
                }

            }
        },
        created() {
            this.load('capabilities');
            this.load('positions');
        }
    }
</script>